// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/style/fonts/icon.css
// module id = 1425
// module chunks = 733